export function trackEvent({ type = "pageview", path = "" }) {
  const o = {
    t: type,
    p: path || window.location.pathname,
    w: window.innerWidth,
    h: window.innerHeight,
  };

  fetch("/api/tr?" + new URLSearchParams(o).toString()).then();
}
